import React from 'react';
import { Card, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useSelector } from 'react-redux';
import IndicatorStatistics from '../IndicatorStatistics';
import EducationCenterIndicators from './EducationCenterIndicators';
import { CombinedStates } from '../../core/types';

const AllIndicatorStatistics: React.FC = () => {
    const { userData } = useSelector((state: CombinedStates) => state.user);

    const schoolsTab: NonNullable<TabsProps['items']>[number] = {
        key: 'schools',
        label: 'Mokyklų rodikliai',
        children: <IndicatorStatistics />,
    };

    const educationCenterTab: NonNullable<TabsProps['items']>[number] = {
        key: 'education_center',
        label: 'Švietimo centro rodikliai',
        children: <EducationCenterIndicators assigned_scope="education_center" />,
    };

    const educationDepartmentTab: NonNullable<TabsProps['items']>[number] = {
        key: 'education_department',
        label: 'Švietimo skyriaus rodikliai',
        children: <EducationCenterIndicators assigned_scope="education_department" />,
    };

    const roleId = userData?.role_id;

    let tabItems: TabsProps['items'] = [schoolsTab];

    if (roleId === 3) {
        tabItems = [schoolsTab, educationDepartmentTab];
    } else if (roleId === 4) {
        tabItems = [schoolsTab, educationCenterTab];
    } else {
        tabItems = [schoolsTab, educationCenterTab, educationDepartmentTab];
    }

    return (
        <div className="all-indicator-statistics">
            <Card>
                <Tabs
                    defaultActiveKey="schools"
                    items={tabItems}
                    className="all-indicator-tabs" />
            </Card>
        </div>
    );
};

export default AllIndicatorStatistics;
